/* 劉備傳・第 2 章：救北海（初平四年，193）
 * 史實：《三國志·太史慈傳》北海相孔融被黃巾管亥圍困，太史慈要突圍去平原向劉備求救。
 *       「慈乃嚴行蓐食，須明，便帶鞬攝弓上馬，將兩騎自隨，各作一的持之，開門直出。外圍下左右人並驚駭，兵馬互出。
 *       慈引馬至城下塹內，植所持的各一，出射之，射之畢，徑入門。明晨復如此，圍下人或起或臥，慈復植的，射之畢，復入門。
 *       明晨復出如此，無復起者，慈乃策馬直突其圍中馳去。」劉備「斂容答曰：『孔北海知世間有劉備邪！』即遣精兵三千人隨慈。賊聞兵至，解圍散走。」
 * 流程：1. 操作太史慈：每天早上出南門，到城下塹內站著射「的」，射完回城。圍兵一天比一天鬆懈（警戒下降）。
 *       第三天之後才能突圍：繞過城往北衝出去；太早衝，圍兵會一擁而上。
 *       2. 改操作劉備：帶精兵三千回來解圍，賊聞兵至散走；斬管亥是額外的星。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, swapPlayer, PEOPLE, rout } from '../kit.ts';
import { CITY, GATE, MOAT, RING_N, GUAN, EXIT } from '../maps/beihai.ts';

const LV = 7, INSIDE = [CITY.x, CITY.y + 200];
const DAY = ['外圍下左右人並驚駭，兵馬互出。', '明晨復如此，圍下人或起或臥。', '明晨復出如此，無復起者。'];

export default {
  id: 'liubei-2', map: 'beihai', hero: 'taishici',
  title: '第 2 章　救北海', year: '初平四年（193）',
  brief: {
    quote: [{ text: '慈乃嚴行蓐食，須明，便帶鞬攝弓上馬，將兩騎自隨，各作一的持之，開門直出。', src: '《三國志·吳書·太史慈傳》' }],
    text: '黃巾管亥圍北海，北海相孔融被困城中。太史慈為報孔融照顧母親的恩情，回來助守，自請突圍去平原向劉備求救。',
    goals: ['每天早上出城射「的」，讓圍兵鬆懈', '第三天之後策馬突圍，往北去平原', '改操作劉備：帶精兵回來解圍'],
  },
  words: { ally: '精兵', foe: '黃巾' },
  stars: [
    { text: '如史：射完三天才突圍', ok: (m) => m.vars.days >= 3 && !m.vars.early },
    { text: '突圍時沒被圍兵碰到', ok: (m) => !m.vars.hitOut },
    { text: '斬管亥', ok: (m) => !!m.vars.guanDead },
  ],
  steps: [
    { // 1. 每日練射
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = INSIDE[0]; me.y = INSIDE[1];
        V.days = 0; V.out = false;
        V.riders = [0, 1].map((i) => { const u = m.recruit(me.x - 60 + i * 120, me.y + 60, '從騎'); m.join(u, me); return u; });
        // 圍兵：北面、東面、西面、南面（管亥大營）
        V.ring = [];
        for (const [cx, cy, n] of [[RING_N[0], RING_N[1], 8], [5300, 3300, 5], [1900, 3300, 5], [4700, 2400, 4]]) for (let i = 0; i < n; i++) { const u = m.foe('huangjin', cx + (i % 4) * 80 - 120, cy + Math.floor(i / 4) * 110, {}); u.home = [u.x, u.y]; u.ringed = true; V.ring.push(u); }
        V.guanArmy = m.camp(GUAN[0], GUAN[1], [['huangjin', 8], ['bandit', 1]], 300);
        V.guan = boss(w, PEOPLE.hanzhong, GUAN[0], GUAN[1] + 60, { name: '管亥', hp: 3200, atk: 44, armor: 7 });
        m.line('孔融', '城中糧盡，子義，非得有人去平原求劉玄德不可。');
        m.after(3, () => m.line('太史慈', '慈願往。'));
        m.after(6, () => m.line('提示', '出南門，到城下塹內（地上的「的」）站著射完再回城。圍兵一天比一天鬆懈；第三天之後再突圍。'));
        m.mark('moat', MOAT[0], MOAT[1], '城下塹內');
        m.obj('days', '出城射的（圍兵的警戒：100%）', 3);
        m.folk(MOAT[0] - 60, MOAT[1] + 40, { name: '的', still: true, near: 1, draw: target });
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, alert = Math.max(0, 100 - V.days * 40);
        const inside = Math.abs(me.x - CITY.x) < CITY.hw && Math.abs(me.y - CITY.y) < CITY.hh;
        // 練射：站在塹內射完，回城就算一天
        if (!V.shot) m.chanAt(me, 'shoot', MOAT[0], MOAT[1], 160, 2.5, '射的', () => { V.shot = true; m.line('太史慈', '（射畢）回城！'); }, { hurt: false });
        if (V.shot && inside) { V.shot = false; V.days++; m.prog('days', Math.min(3, V.days)); m.card(DAY[Math.min(2, V.days - 1)], '《太史慈傳》'); if (V.days < 3) m.after(2, () => m.line('旁白', '第二天早上……')); }
        m.get('days').text = `出城射的（圍兵的警戒：${alert}%）`;
        // 圍兵：太史慈出城時，警戒高就圍過來看（但射完回城就散）
        for (const u of V.ring) {
          if (!u.alive) continue;
          const watch = !inside && alert > 0 && SG.gd(u.x, u.y, me.x, me.y) < 900 + alert * 6;
          if (watch && alert >= 60) { u.home = [me.x + (u.x - me.x) * 0.6, me.y + (u.y - me.y) * 0.6]; } else u.home = u.ringHome || (u.ringHome = u.home.slice());
          if (alert < 60 && !V.early) { u.target = null; u.think = 0.5; } // 或起或臥、無復起者：不理他
        }
        // 突圍：往北走過北面的圍營
        if (me.y < RING_N[1] - 500) { if (V.days < 3) V.early = true; return true; }
        if (V.days < 3 && me.y < CITY.y - CITY.hh - 200 && !V.early) { V.early = true; m.line('黃巾', '有人要跑！攔住他！'); for (const u of V.ring) if (u.alive) { u.home = [me.x, me.y]; } for (const dx of [-1400, -700, 0, 700, 1400]) m.gate('block' + dx, RING_N[0] + dx, RING_N[1] - 60, 420, dx ? null : 'abatis'); } // 太早衝：北面的圍營整排堵住
        if (m.gates.some((g) => g.id.startsWith('block')) && V.ring.slice(0, 8).filter((u) => u.alive).length <= 2) for (const dx of [-1400, -700, 0, 700, 1400]) m.ungate('block' + dx);
        return false;
      },
    },
    { // 2. 策馬直突其圍中馳去
      enter(m, w) {
        const V = m.vars;
        m.done('days'); m.unmark('moat');
        m.card('慈乃策馬直突其圍中馳去。', '《太史慈傳》');
        m.mark('exit', EXIT[0], EXIT[1], '平原');
        m.obj('go', '往北去平原求救');
        V.hp0 = w.player.hp;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (me.hp < V.hp0 - 1) V.hitOut = true;
        V.hp0 = Math.min(V.hp0, me.hp);
        return m.near(me, EXIT[0], EXIT[1] + 150, 300);
      },
    },
    { // 3. 劉備遣精兵三千
      enter(m, w) {
        const V = m.vars, ci = w.player;
        m.done('go'); m.unmark('exit');
        m.line('太史慈', '北海被圍，孔北海知道劉玄德仁義，特來求救。');
        m.after(2.5, () => m.card('先主斂容答曰：「孔北海知世間有劉備邪！」即遣精兵三千人隨慈。', '《太史慈傳》'));
        const lb = ally(w, 'liubei', EXIT[0] + 120, EXIT[1] + 200, LV + 1);
        swapPlayer(w, lb);
        V.ci = ci;
        V.army = Array.from({ length: 12 }, (_, i) => { const u = m.recruit(lb.x - 150 + (i % 4) * 70, lb.y + 120 + Math.floor(i / 4) * 70, '精兵'); u.spec = SG.SOLDIERS.shu; m.join(u, lb); return u; });
        m.after(6, () => m.line('提示', '現在操作劉備：帶精兵回北海解圍。'));
        m.mark('city', CITY.x, CITY.y, '北海');
        m.obj('relief', '帶精兵回北海解圍');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!V.fled && SG.gd(me.x, me.y, CITY.x, CITY.y) < 1500) {
          V.fled = true;
          m.card('賊聞兵至，解圍散走。', '《太史慈傳》');
          rout(m, w, V.ring.concat(V.guanArmy), [3600, 5500]);
          V.guan.home = [3600, 5400]; V.guan.ms = 200;
          m.mark('guan', V.guan.x, V.guan.y, '管亥（逃走中）', false, V.guan);
          m.obj('guan', '（額外）追斬管亥');
          m.after(25, () => { if (!m.over) m.win(); });
        }
        if (V.fled && !V.guan.alive && !V.guanDead) { V.guanDead = true; m.done('guan'); m.unmark('guan'); m.after(3, () => m.win()); }
        return false;
      },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose(m.i >= 2 ? '劉備陣亡' : '太史慈陣亡'); return; }
    if (m.vars.ci && m.vars.ci.alive) allyTick(w, m.vars.ci, w.player);
  },
};

// 的：插在塹內的箭靶
function target(ctx, f, T) {
  ctx.save(); ctx.translate(f.x, f.y);
  ctx.strokeStyle = '#5a3a22'; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(0, -60); ctx.stroke();
  for (const [r, c] of [[22, '#e9dcb8'], [15, '#b0443a'], [8, '#e9dcb8'], [3, '#b0443a']]) { ctx.fillStyle = c; ctx.beginPath(); ctx.arc(0, -70, r, 0, Math.PI * 2); ctx.fill(); }
  ctx.restore();
}
